// extracted by mini-css-extract-plugin
export default {"revenueContent":"Bundles_revenueContent__-Gxiu"};